export function downloadBlob(blob, filename) {
  if (!blob) throw new Error('No blob provided for download');
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  // Revoke slightly later to avoid interrupting the download in some browsers
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export function downloadHref(href, filename) {
  if (!href) throw new Error('No href provided for download');
  const link = document.createElement('a');
  link.href = href;
  if (filename) link.download = filename;
  link.rel = 'noopener';
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export async function downloadDataUrl(dataUrl, filename) {
  if (!dataUrl) throw new Error('No data URL provided for download');
  // Convert data URL → Blob for more reliable downloads across browsers.
  const res = await fetch(dataUrl);
  const blob = await res.blob();
  downloadBlob(blob, filename);
}

export function downloadText(text, filename, mimeType) {
  if (typeof text !== 'string') throw new Error('No text provided for download');
  const blob = new Blob([text], { type: mimeType || 'text/plain;charset=utf-8' });
  downloadBlob(blob, filename);
}

